export enum RoleId {
  SA = 1,
  ADMIN = 2,
  FSM = 3,
  AM = 4,
  ISF = 5,
  SP = 6,
}

export interface User {
  email: string;
  id: string;
  name: string;
  role: Role;
  surname: string;
  unlockedIsfResponse?: {
    unlocked: boolean;
    startUnlockDate: string;
    endUnlockDate: string;
  };
}

export interface Role {
  id: number;
  name: string;
}
